function initGsCardRotateClockwise() {
  const els = gsap.utils.toArray(".gs-card-rotate-clockwise");
  console.log("旋转元素数量：", els.length);
  if (!els.length) return;
  els.forEach(el => {
    gsap.fromTo(el,
      { rotate: 0 },
      {
        rotate: 360,
        duration: 10,
        ease: "none",
        repeat: -1,
      }
    );
  });
}

function initRegionalImgAnimate () {
  if (!gsap) return;
  gsap.registerPlugin(ScrollTrigger);

  const allItems = gsap.utils.toArray(`
    .regional .imgbox_t1, .regional .imgbox_t2, .regional .imgbox_t3, .regional .imgbox_t4,
    .regional .imgbox_t5, .regional .imgbox_t6, .regional .imgbox_t7, .regional .imgbox_t8, .regional .imgbox_t9, .regional .imgbox_t10, .regional .imgbox_t11, .regional .imgbox_t12, .regional .imgbox_t13,
    .regional .imgbox_t14, .regional .imgbox_t15, .regional .imgbox_t16, .regional .imgbox_t17, .regional .imgbox_t18, .regional .imgbox_t19, .regional .imgbox_t20, .regional .imgbox_t21, .regional .imgbox_t22, .regional .imgbox_t23
  `);

  const regionalWrap = document.querySelector(".regional");
  if (!regionalWrap || !allItems.length) return;

  // 初始状态：透明 + 缩小
  gsap.set(allItems, { opacity: 0, scale: 0.8 });

  // 出场时间线：按 DOM 顺序逐个显示（保持不变）
  const mainTl = gsap.timeline({ paused: true });
  mainTl.to(allItems, {
    opacity: 1,
    scale: 1,
    duration: 0.6,
    stagger: 0.08,
    ease: "power2.out"
  });

  // ========== 随机元素呼吸动画 ==========
  let lastPicked = [];
  // 每次随机选中多少个元素
  const pickCount = 8;
  // 两轮随机之间的间隔时间
  const intervalTime = 0;

  function randomPulseLoop() {
    // 过滤掉上一轮选中的，避免连续重复
    const pool = allItems.filter(item => !lastPicked.includes(item));
    // 打乱数组，取出 pickCount 个
    const shuffled = gsap.utils.shuffle(pool);
    const selected = shuffled.slice(0, pickCount);
    lastPicked = selected;

    gsap.timeline()
      .to(selected, { scale: 1.15, duration: 0.5, ease: "sine.out" })
      .to(selected, { scale: 1, duration: 0.7, ease: "sine.inOut" })
      .delay(intervalTime)
      .call(randomPulseLoop);
  }
  // 启动随机循环
  randomPulseLoop();


  ScrollTrigger.create({
    trigger: regionalWrap,
    start: "30% 50%",
    end: "bottom 80%",
    markers: false,
    onUpdate: (self) => {
      const p = self.progress;
      // 滚动进度驱动出场，回滚元素依次隐藏
      mainTl.progress(p);
    }
  });
}



window.addEventListener('load', () => {
  initGsCardRotateClockwise();
  initRegionalImgAnimate();
});




function initMarketResponseAnim(){
    if(!gsap) return;
    gsap.registerPlugin(ScrollTrigger);
    const wrap = document.querySelector(".market_response");
    if(!wrap) return;
    const img1 = wrap.querySelector(".imgbox1");
    const img2 = wrap.querySelector(".imgbox2");
    // 同时获取 PC 和移动端两套 title
    const titleList = wrap.querySelectorAll(".textbox .title");
    const text1 = wrap.querySelector(".textbox .text1");
    const text2 = wrap.querySelector(".textbox .text2");

    const tl = gsap.timeline({
        defaults:{duration:1}
    });
    tl
    // 1.imgbox1 左进
    .to(img1,{
        opacity:1,
        translateX:0,
        ease:"power2.out"
    })
    // 2.imgbox2 右进
    .to(img2,{
        opacity:1,
        translateX:0,
        ease:"power2.out"
    })
    //3. 两套title同时做动画（querySelectorAll返回集合，gsap原生支持传入集合）
    .to(titleList,{opacity:1,ease:"power2.out"})
    //4.text1
    .to(text1,{opacity:1,ease:"power2.out"})
    //5.text2
    .to(text2,{opacity:1,ease:"power2.out"});

    let bounceTl = null;
    ScrollTrigger.create({
        trigger: wrap,
        start:"50% 80%",
        end:"80% 80%",
        animation: tl,
        scrub: 0.4,
        onEnter:()=>{
            if(!bounceTl){
                bounceTl = gsap.timeline();
                bounceTl
                .to(img1,{scale:1.06,duration:0.2})
                .to(img1,{scale:1,duration:0.3})
                .to(img2,{scale:1.06,duration:0.2})
                .to(img2,{scale:1,duration:0.3});
            }
        },
        onLeaveBack:()=>{
            if(bounceTl){
                bounceTl.kill();
                bounceTl=null;
                gsap.set([img1,img2],{scale:1});
            }
        }
    });
}
window.addEventListener('load',()=>{
    initMarketResponseAnim();
})



function initSwiper(){
  const el = document.querySelector(".swpierbox .box-swiper");
  if(!el){
    console.error("未找到 .box-swiper 节点，检查HTML结构和选择器");
    return;
  }
  if(typeof Swiper === "undefined"){
    console.error("Swiper库未加载，检查CDN或本地脚本路径");
    return;
  }
  const slideCount = el.querySelectorAll('.swiper-slide').length;
  const swiper = new Swiper(el, {
    effect:"coverflow",
    grabCursor:true,
    centeredSlides:true,
    spaceBetween:20,
    loop:false,
    allowTouchMove:true,
    speed:650,
    initialSlide: Math.min(2, slideCount -1),
    watchSlidesProgress:true,
    coverflowEffect:{
      rotate:-11,
      stretch:0,
      depth:180,
      modifier:1.4,
      slideShadows:false
    },
    // 导航箭头
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // 分页dots配置
    pagination: {
      el: '.swiper-pagination',
      clickable: true, // 点击圆点可以切换
      dynamicBullets: true, // 动态圆点，当前放大
    },
    breakpoints: {
      0: {
        slidesPerView: 3,
        spaceBetween: 12,
        coverflowEffect:{
          rotate:-6,
          depth:100,
          modifier:1.2
        },
        // 移动端：关闭箭头，开启分页
        navigation: false,
        pagination: {
          el: '.swiper-pagination',
          clickable:true,
          dynamicBullets:true
        }
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 20,
        coverflowEffect:{
          rotate:-11,
          depth:180,
          modifier:1.4
        },
        // PC：开启箭头，关闭分页
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      }
    }
  });
}
if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", initSwiper);
}else{
  initSwiper();
}



